var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome24 = function SvgHome24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.543 3.665a3 3 0 0 1 2.914 0l8.029 4.46a1 1 0 1 1-.971 1.75L20 9.587V16a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9.588l-.514.286a1 1 0 1 1-.971-1.748l8.028-4.46ZM6 8.618V16c0 1.306.835 2.418 2 2.83V18a4 4 0 0 1 8 0v.83A3.001 3.001 0 0 0 18 16V8.618l-6-3-6 3ZM10 18a2 2 0 1 1 4 0v1h-4v-1Z",
    fill: "currentColor"
  })));
};
export default SvgHome24;